import React from "react";
import {
  AnimatePresence,
  motion,
  useCycle,
} from "framer-motion/dist/framer-motion";

export function Para() {
  return (
    <>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        name
      </motion.p>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        class="hoisting-error"
      >
        unintialized
      </motion.p>
    </>
  );
}
